export default {
  getSales(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`/card-machine/sales?${queryString}`)
        .then(({ data: { count, next, previous, results } }) => {
          context.commit("setSales", results);
          context.commit("setPagination", {
            count,
            next,
            previous
          });
          resolve({ count, next, previous, results });
        })
        .catch(reject);
    });
  },
  postSale(context, params) {
    return new Promise((resolve, reject) => {
      return window.axios
        .post(`/card-machine/sales`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  putSale(context, params) {
    return new Promise((resolve, reject) => {
      return window.axios
        .put(`/card-machine/sales/${params.id}`, params)
        .then(resolve)
        .catch(reject);
    });
  }
};
